// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".round--normal[data-v-c1a9b91e]{background-color:#099}.round--error[data-v-c1a9b91e],.round--normal[data-v-c1a9b91e]{width:36px;height:36px;border-radius:50%;color:#fff;position:relative}.round--error[data-v-c1a9b91e]{background-color:red}p[data-v-c1a9b91e]{font-weight:700;margin:0;position:absolute;top:45%;left:50%;margin-right:-50%;transform:translate(-50%,-50%)}", ""]);
// Exports
module.exports = exports;
